import { request } from '@umijs/max';
import type { Response } from 'types';
import type { LoginParams, LoginRes } from './type';

/**
 * 登录
 */
export function login(params: LoginParams) {
  return request<Response<LoginRes>>(`/api/admin/auth/login`, {
    method: 'post',
    data: params
  });
}

/**
 * 退出登录
 */
export function logout() {
  return request(`/api/admin/auth/logout`, {
    method: 'post',
  });
}
